<template>
  <div id="problem" v-if="userinfo.username.length != 0">
    <h1 class="mt-4">{{ this.problem.title }}</h1>
    <br />

    <b-container>
      <b-table-simple
        bordered
        class="mt-3"
        style="text-align: center"
        id="info"
      >
        <b-tr>
          <b-th class="col-md-4">Deadline</b-th>
          <b-th class="col-md-4">Time left</b-th>
          <b-th class="col-md-4">Total Score</b-th>
        </b-tr>
        <b-tr>
          <b-td>{{ problem.score_end_date.replace(/T/, " ") }}</b-td>
          <b-td v-if="time_danger" style="color: #dc3545; font-weight: bold">{{
            deadline_time
          }}</b-td>
          <b-td v-else>{{ deadline_time }}</b-td>
          <b-td
            v-if="sum_score >= 100"
            style="color: #28a745; font-weight: bold"
            >{{ sum_score }}</b-td
          >
          <b-td v-else-if="sum_score >= 80" style="color: #007bff">{{
            sum_score
          }}</b-td>
          <b-td v-else-if="sum_score >= 60" style="color: #fd7e14">{{
            sum_score
          }}</b-td>
          <b-td v-else style="color: #dc3545; font-weight: bold">{{
            sum_score
          }}</b-td>
        </b-tr>
      </b-table-simple>
      <object
        :data="pdfURL"
        type="application/pdf"
        height="600px"
        width="100%"
        style="margin-bottom: 20px"
      >
        <p style="margin-top: 40px; margin-bottom: 40px; text-align: center">
          It appears the PDF files haven't been uploaded by TAs yet or your web
          broswer is like a shit.
          <br />
          Please Contact TAs, Thanks!
        </p>
      </object>
      <b-form @submit="startJudge">
        <div v-if="userinfo.isActive">
          <div v-if="problem_attributes[0].title != ''">
            <h1 class="mt-4">Input Data</h1>
            <div
              class="form-row"
              v-for="(checkpoint, index) in problem_attributes"
              :key="index"
              style="margin-bottom: 10px"
            >
              <b-input-group
                :prepend="problem_attributes[index].title"
                class="mt-2"
              >
                <b-form-input
                  required
                  :disabled="cooldown_seconds != 0 && !userinfo.isAdmin"
                  v-model="problem_attributes[index].value"
                ></b-form-input>
              </b-input-group>
            </div>
          </div>
          <center>
            <div v-if="cooldown_seconds != 0">
              <b-button disabled variant="primary"
                >Waiting for {{ cooldown_seconds }} seconds.</b-button
              >
            </div>
            <div v-else>
              <b-button
                variant="primary"
                type="submit"
                :disabled="disableSubmit"
                >Submit</b-button
              >
            </div>
          </center>
        </div>
        <center v-if="userinfo.isAdmin">
          <b-input-group prepend="username" class="mt-4" style="width: 800px">
            <b-form-input
              v-model="runAs"
              :state="userState"
              :placeholder="userinfo.username"
              aria-describedby="userNotFound username-help"
            ></b-form-input>
            <b-input-group-append>
              <b-button
                variant="primary"
                @click="
                  admin_submit = true;
                  startJudge();
                "
                :disabled="!userState || admin_submit_disable"
                >{{ admin_submit_msg }}</b-button
              >
              <b-button
                variant="success"
                @click="editProblem($route.params.id)"
                style="white-space: nowrap"
                >Edit Problem</b-button
              >
              <b-button
                variant="info"
                @click="editCheckpoint($route.params.id)"
                style="white-space: nowrap"
                >Edit Checkpoint</b-button
              >
            </b-input-group-append>
            <b-form-text id="username-help"
              >Enter username to run as User, or keep blank to run by userself
              ({{ userinfo.username }}).</b-form-text
            >
            <b-form-invalid-feedback id="userNotFound" style="text-align: left">
              User {{ runAs }} is not found.
            </b-form-invalid-feedback>
          </b-input-group>
        </center>
      </b-form>
      <br />
      <b-table
        :fields="fields"
        :items="checkpoint_display"
        :sort-by.sync="sortBy"
        aria-sorthover
        outlined
      >
        <template #cell(status)="data">
          <!--
          <b-button size="sm" variant="primary" :href="`#/problem/${data.item.id}`">{{ data.value }}</b-button>
          -->
          <b-button
            v-if="userinfo.isActive"
            size="sm"
            :variant="variantstatus"
            :disabled="disbtn"
            v-b-modal.checkpoint-log
            @click="
              update_checkpoint_status(data.item.id);
              $refs['checkpoint-log'].show();
            "
            >View</b-button
          >
          <b-button v-else size="sm" disabled="true">View</b-button>
        </template>
      </b-table>
    </b-container>
    <b-modal
      id="checkpoint-log"
      ref="checkpoint-log"
      size="xl"
      hide-footer
      title="Terminal"
    >
      <div
        style="
          background-color: black;
          color: white;
          font-family: 'Courier New';
          padding: 10px 10px 10px;
          border-radius: 5px;
        "
        v-html="checkpoint_log"
      ></div>
      <div class="col text-center">
        <b-button
          class="mt-3"
          @click="update_checkpoint_status(checkpoint_id)"
          variant="primary"
          >Refresh</b-button
        >
      </div>
    </b-modal>
    <b-modal id="msg" ref="msg">
      <div>
        <center>
          {{ cooldown_msg }}
        </center>
      </div>
    </b-modal>
  </div>
</template>

<script>
import AnsiUp from "ansi_up";
var ansi_up = new AnsiUp();

export default {
  created() {
    let self = this;
    this.get_user_info();
    this.getAttributes();
    this.access_token = localStorage.getItem("access_token");
    this.timer();
    this.$http
      .get(this.api_problem, {
        headers: {
          Authorization: "Bearer " + this.access_token,
        },
      })
      .then((response) => {
        self.problem = response.data;
        self.pdfURL =
          "https://drive.google.com/file/d/" +
          response.data.description +
          "/preview";

        let now = new Date();
        let deadline = new Date(self.problem.score_end_date);

        let timeInterval = setInterval(function () {
          if (deadline - now > 0) {
            let newNow = new Date();
            self.deadline_time = self.remain_time_string(deadline, newNow);
          } else {
            clearInterval(timeInterval);
            self.deadline_time = "00:00";
            self.disableSubmit = true;
          }
        }, 1000);
      });

    this.$http
      .get(this.api_checkpoint, {
        headers: {
          Authorization: "Bearer " + this.access_token,
        },
      })
      .then((response) => {
        self.checkpoint = response.data;
        self.checkpoint_display = [];
        self.get_all_checkpoint_status();

        self.checkpoint.forEach(function (item) {
          self.score_list.push({
            id: item.id,
            score: 0,
          });
          self.checkpoint_display.push({
            title: item.title,
            score: "0/" + item.score,
            problem_id: item.problem_id,
            id: item.id,
            job_name: item.job_name,
          });
        });

        //for (let i in response.data) {
        //  self.checkpoint_display[i].score = "0/" + this.checkpoint[i].score;
        //}
        setInterval(function () {
          self.getScore2();
        }, 1000);
      });
  },

  data() {
    return {
      sum_score: 0,

      fields: [
        {
          key: "id",
          label: "ID",
          sortable: false,
        },
        {
          key: "title",
          label: "Check Point",
        },
        {
          key: "score",
          label: "Score",
        },
        {
          key: "status",
          label: "Status",
        },
      ],
      items: [],
      problem: {
        score_end_date: "",
      },
      checkpoint: [],
      checkpoint_display: [],
      userinfo: {
        username: "",
        isAdmin: false,
        isActive: false,
      },
      access_token: "",
      msg: "",
      api_checkpoint: "/problem/" + this.$route.params.id + "/checkpoint",
      api_problem: "/problem/" + this.$route.params.id,
      api_problem_score: "/problem/" + this.$route.params.id + "/score",
      api_user: "/user/me",
      judge_result_id: "",
      disbtn: true,
      variantstatus: "primary",
      checkpoint_log: "",
      checkpoint_data: undefined,
      checkpoint_title: "",
      checkpoint_id: 0,
      ansi: undefined,
      cooldown_msg: undefined,
      isCooldown: false,
      cooldown_seconds: 0,
      timeInterval: 0,
      sortBy: "id",
      pdfwidth: 0,
      pdfURL: undefined,
      problem_attributes: [{ title: "" }],
      runAs: undefined,
      users: [{ username: "" }],
      deadline_msg: "",
      deadline_time: "",
      disableSubmit: false,
      admin_submit: false,
      admin_submit_msg: "Submit (Admin)",
      admin_submit_disable: false,
      time_danger: false,
      score_list: [],
    };
  },
  mounted() {
  },
  computed: {
    userState() {
      let self = this;
      if (this.runAs == undefined || this.runAs == "") return true;
      return this.users.some((e) => e.username == self.runAs);
    },
    checkInputLength(string) {
      return string.length > 0 ? true : false;
    },
  },
  methods: {
    startJudge() {
      this.clear_scores();
      let self = this;
      this.checkRunAsUser();
      if (!self.admin_submit) {
        this.cooldown_seconds = this.problem.cooldown_minutes * 60;
        let timeInterval = setInterval(function () {
          if (self.cooldown_seconds != 0) {
            self.cooldown_seconds -= 1;
          } else {
            clearInterval(timeInterval);
          }
        }, 1000);
        self.admin_submit = false;
      }
      if (self.admin_submit) {
        let wait = 5;
        self.admin_submit_msg = "Wait " + wait + " s (Admin)";
        self.admin_submit_disable = true;
        let timeInterval2 = setInterval(function () {
          if (wait != 0) {
            wait -= 1;
            self.admin_submit_msg = "Wait " + wait + " s (Admin)";
          } else {
            clearInterval(timeInterval2);
            self.admin_submit_disable = false;
            self.admin_submit_msg = "Submit (Admin)";
          }
        }, 1000);
        self.timer();
      }
      let attribute_values = [];
      this.problem_attributes.forEach(function (item) {
        let attr = {};
        if (self.userExist && self.userinfo.isAdmin) {
          attr = {
            attribute_id: item.id,
            username: self.runAs,
            value: item.value,
          };
        } else {
          attr = {
            attribute_id: item.id,
            username: self.userinfo.username,
            value: item.value,
          };
        }
        attribute_values.push(attr);
      });
      let api_judge = "/judge/start";

      let data = {};
      if (attribute_values[0].attribute_id != undefined) {
        if (self.userExist && self.userinfo.isAdmin) {
          data = {
            problem_id: this.problem.id,
            username: this.runAs,
            attribute_values: attribute_values,
          };
        } else {
          data = {
            problem_id: this.problem.id,
            username: this.userinfo.username,
            attribute_values: attribute_values,
          };
        }
      } else {
        if (self.userExist && self.userinfo.isAdmin) {
          data = {
            problem_id: this.problem.id,
            username: this.runAs,
          };
        } else {
          data = {
            problem_id: this.problem.id,
            username: this.userinfo.username,
          };
        }
      }
      this.$http
        .post(api_judge, data, {
          headers: {
            Authorization: "Bearer " + this.access_token,
          },
        })
        .then((response) => {
          self.judge_result_id = response.data.id;
          self.disbtn = false;
          self.variantstatus = "primary";
          self.checkpoint_status();
          if (self.checkRunAsUser()) {
            self.$router.push({
              name: "Submission",
              params: {
                id: self.judge_result_id,
              },
            });
          }
        })
        .catch(function (error) {
          if (error.response) {
            self.isCooldown = true;
            self.cooldown_msg = error.response.data["detail"];
            self.showMsg();
          }
        });
    },
    remain_time_string(startDate, endDate) {
      let diff = startDate.getTime() - endDate.getTime();
      let days = Math.floor(diff / 1000 / 60 / 60 / 24);
      if (days < 3) {
        this.time_danger = true;
      }
      diff -= days * 1000 * 60 * 60 * 24;
      let hours = Math.floor(diff / 1000 / 60 / 60);
      if (hours.toString().length == 1) {
        hours = "0" + hours;
      }
      diff -= hours * 1000 * 60 * 60;
      let minutes = Math.floor(diff / 1000 / 60);
      if (minutes.toString().length == 1) {
        minutes = "0" + minutes;
      }
      diff -= minutes * 1000 * 60;
      let seconds = Math.floor(diff / 1000);
      if (seconds.toString().length == 1) {
        seconds = "0" + seconds;
      }
      return days + " Day " + hours + ":" + minutes + ":" + seconds;
    },
    get_checkpoint_logs(judge_result_id, id) {
      let self = this;
      this.$http
        .get("/judge/result/" + judge_result_id + "/checkpoint", {
          headers: {
            Authorization: "Bearer " + this.access_token,
          },
        })
        .then((response) => {
          let index = response.data.findIndex((e) => e.check_point_id == id);
          self.checkpoint_log = ansi_up
            .ansi_to_html(response.data[index].log)
            .replace(/\n/gm, "<br>");
        });
    },
    log() {
      return this.checkpoint_log;
    },
    cooldown() {
      return "cooldown";
    },
    showMsg() {
      this.$refs["msg"].show();
    },
    showTerminal() {
      this.$refs["checkpoint-log"].show();
    },
    view_checkpoint_log(checkpoint_id) {
      this.update_checkpoint_status(checkpoint_id);
      if (self.judge_result_id != undefined) {
        this.get_checkpoint_logs(self.judge_result_id, checkpoint_id);
      }
    },
    get_all_checkpoint_status() {
      let self = this;
      this.checkpoint.forEach(function (item) {
        self.update_checkpoint_status(item.id);
        self.getScore2();
      });
    },
    update_checkpoint_status(checkpoint_id) {
      let self = this;
      self.disbtn = false;
      self.checkpoint_id = checkpoint_id;
      let api =
        "/problem/" +
        this.$route.params.id +
        "/checkpoint/" +
        checkpoint_id +
        "/score";
      this.$http
        .get(api, {
          headers: {
            Authorization: "Bearer " + this.access_token,
          },
        })
        .then((response) => {
          let score = response.data;

          if (response.data.log == undefined || response.data.log == "") {
            self.checkpoint_log = "None";
          } else {
            self.checkpoint_log = ansi_up
              .ansi_to_html(response.data.log)
              .replace(/\n/gm, "<br>");
          }
          self.judge_result_id = score.judge_result_id;
          if (score.passed) {
            let index = self.checkpoint_display.findIndex(
              (e) => e.id === score.check_point_id
            );
            self.score_list[index].score = self.checkpoint[index].score;
            self.checkpoint_display[index].score =
              self.checkpoint[index].score + "/" + self.checkpoint[index].score;
            self.disbtn = false;
            self.variantstatus = "primary";
          }
          /*
          else {
            self.disbtn = false;
            self.variantstatus = "primary";
            self.checkpoint_display[index].score = "0/" + self.checkpoint[index].score;
          }
  */
          self.checkpoint.forEach(function (item, i) {
            if (item.id === score.check_point_id) {
              if (score.passed) {
                self.checkpoint_display[i].score =
                  item.score + "/" + item.score;
                self.disbtn = false;
                self.variantstatus = "primary";
              } else {
                self.disbtn = false;
                self.variantstatus = "primary";
                self.checkpoint_display[i].score = "0/" + item.score;
              }
            }
          });
        });
    },
    clear_scores() {
      let self = this;
      self.checkpoint.forEach(function (item, i) {
        self.checkpoint_display[i].score = "0/" + item.score;
      });
    },
    checkpoint_status(data) {
      let self = this;
      self.checkpoint_data = data;
      try {
        self.checkpoint_title = data.item.title;
      } catch (error) {
        self.checkpoint_title = "";
      }

      //console.log(data);
      this.checkpoint_log = "Loading...";
      //const api_result_checkpoint =
      //  "/judge/result/" + this.judge_result_id + "/checkpoint";
      let api =
        "/problem/" +
        this.$route.params.id +
        "/checkpoint/" +
        data.item.id +
        "/score";
      this.$http
        .get(api, {
          headers: {
            Authorization: "Bearer " + this.access_token,
          },
        })
        .then((response) => {
          /* 
          for (let score of response.data) {
            self.judge_result_id = score.judge_result_id;
            for (let i in self.checkpoint) {
              if (self.checkpoint[i].id === score.check_point_id) {
                if (score.passed) {
                  self.checkpoint_display[i].score =
                    self.checkpoint[i].score + "/" + self.checkpoint[i].score;
                  self.disbtn = false;
                  self.variantstatus = "primary";
                } else {
                  self.disbtn = false;
                  self.variantstatus = "primary";
                  self.checkpoint_display[i].score =
                    "0/" + self.checkpoint[i].score;
                }
              }
            }
          }
          */
          let score = response.data;
          self.judge_result_id = score.judge_result_id;
          for (let i in self.checkpoint) {
            if (self.checkpoint[i].id === score.check_point_id) {
              if (score.passed) {
                self.checkpoint_display[i].score =
                  self.checkpoint[i].score + "/" + self.checkpoint[i].score;
                self.disbtn = false;
                self.variantstatus = "primary";
              } else {
                self.disbtn = false;
                self.variantstatus = "primary";
                self.checkpoint_display[i].score =
                  "0/" + self.checkpoint[i].score;
              }
            }
          }
          if (data != undefined) {
            self.get_checkpoint_logs(self.judge_result_id, data.item.id);
          }
        });
      if (this.judge_result_id !== "") {
        this.disbtn = false;
        this.variantstatus = "primary";
      }
      self.getScore2();
    },
    editProblem(problem_id) {
      let self = this;
      this.$router.push({
        name: "EditProblem",
        params: {
          id: problem_id,
          userinfo: self.userinfo,
        },
      });
    },
    editCheckpoint(problem_id) {
      let self = this;
      this.$router.push({
        name: "EditCheckpoint",
        params: {
          id: problem_id,
          userinfo: self.userinfo,
        },
      });
    },
    get_user_info() {
      let self = this;
      let api = "/user/me";
      this.access_token = localStorage.getItem("access_token");
      this.$http
        .get(api, {
          headers: {
            Authorization: "Bearer " + this.access_token,
          },
        })
        .then((response) => {
          self.userinfo = response.data;
          if (response.data.isAdmin) this.get_user_list();
        })
        .catch(function (error) {
          if (error.response) {
            if (error.response.status == 422) {
              localStorage.clear();
              location.replace("/");
            }
          }
        });
    },
    get_user_list() {
      let api = "/user/";
      let access_token = localStorage.getItem("access_token");
      this.$http
        .get(api, {
          headers: {
            Authorization: "Bearer " + access_token,
          },
        })
        .then((response) => {
          this.users = response.data;
        });
    },
    getScore() {
      let access_token = localStorage.getItem("access_token");
      let api = "/problem/" + this.$route.params.id + "/score";
      let self = this;
      this.$http
        .get(api, {
          headers: {
            Authorization: "Bearer " + access_token,
          },
        })
        .then((response) => {
          self.sum_score = response.data;
        });
    },
    getScore2() {
      let self = this;
      self.sum_score = 0;
      this.score_list.forEach(function (checkpoint) {
        self.sum_score += checkpoint.score;
      });
    },
    getAttributes() {
      let access_token = localStorage.getItem("access_token");
      let api = "/problem/" + this.$route.params.id + "/attribute";
      let self = this;
      this.$http
        .get(api, {
          headers: {
            Authorization: "Bearer " + access_token,
          },
        })
        .then((response) => {
          if (response.data.length != 0) {
            self.problem_attributes = response.data.sort(function (a, b) {
              return a.id > b.id ? 1 : -1;
            });
            self.problem_attributes.forEach(function (item) {
              item.value = "";
            });
            self.origin_attribute_num = self.problem_attributes.length;
          } else {
            self.problem_attributes = [
              {
                title: "",
              },
            ];
          }
        })
        .catch(function (error) {
          if (error.response) {
            //console.log(error);
          }
        });
    },
    timer() {
      let access_token = localStorage.getItem("access_token");
      let api = "/problem/" + this.$route.params.id + "/cooldown";
      let self = this;
      this.$http
        .get(api, {
          headers: {
            Authorization: "Bearer " + access_token,
          },
        })
        .then((response) => {
          self.cooldown_seconds = response.data.seconds;
          if (self.cooldown_seconds != 0) {
            this.timeInterval = setInterval(function () {
              if (self.cooldown_seconds != 0) {
                self.cooldown_seconds -= 1;
              } else {
                clearInterval(self.timeInterval);
              }
            }, 1000);
          }
        });
    },
    checkRunAsUser() {
      let self = this;
      this.userExist = this.users.some((e) => e.username == self.runAs);
      return this.userExist;
    },
  },
};
</script>
<style>
h1,
h3 {
  text-align: center;
}
#new {
  text-align: center;
}
</style>